import JobBoardPdf from "components/Pdfs/JobBoardProductPdfPrintButton/JobBoardPdf";
import QuickViewWorkOrder from "components/QuickViewWorkOrder/QuickViewWorkOrder";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";
import "./DisplayBoard.css";
import JobBoardFullViewData from "./JobBoardFullViewData";
import { useSearchParams } from "react-router-dom";

export default function ProductWiseItem({
  filterBy,
  filterText,
  tempBoard = false,
  selectedLocation,
  productTypesData,
  refreshStatusList,
  setRefreshStatusList,
}) {
  const dispatch = useDispatch();
  /*   All States
   ********************************************* */

  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const [showProductsModal, setShowProductsModal] = useState(false);
  const [openFullView, setOpenFullView] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [WOData, setWOData] = useState([]);
  const [filteredSearchedData, setFilteredSearchedData] = useState(null);

  const [refresh, setRefresh] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  /*   All Functions
   ********************************************* */
  const loadingOn = () => {
    setLoading(true);
  };

  const loadingOff = () => {
    setLoading(false);
  };

  const updateSearchParams = (key, value) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);

      if (value) {
        newParams.set(key, value);
      } else {
        newParams.delete(key);
      }

      return newParams.toString();
    });
  };

  const getTotalQty = (products) => {
    if (products && products.length > 0) {
      let totalQty = 0;

      // filtering out the products which are not in the selected product type
      products = products.filter((item) => {
        return item?.productTypeId === filterBy?.productTypeId;
      });

      // calculating the total quantity of the filtered products
      products?.map((item) => {
        totalQty += item?.totalQuantity;
      });
      return totalQty;
    } else {
      return 0;
    }
  };

  const getWOByproductType = async ({ pageNo = 1, reset = true } = {}) => {
    try {
      loadingOn();
      let apiPath = `/job-board/product-type?page=${pageNo}&limit=${limit}`;

      const { data } = await API.post(
        apiPath,
        {
          productTypeId: filterBy.productTypeId,
          query: filterText?.trim() || undefined,
        },
        { headers: authHeader() },
      );

      if (data?.success) {
        const incoming = data?.data || [];
        setWOData((prev) =>
          reset ? incoming : [...(prev || []), ...incoming],
        );

        setPage(data?.page || pageNo);
        setTotalPages(data?.totalPages || 1);
        setTotalRecords(data?.total || 0);
        setRefresh(false);
        setRefreshStatusList((prev) => {
          prev[filterBy.productTypes] = false;
          return prev;
        });
        loadingOff();
        return data.result;
      }

      if (data?.type === "success") {
        const incoming = data?.result || [];
        setWOData((prev) =>
          reset ? incoming : [...(prev || []), ...incoming],
        );
        setPage(1);
        setTotalPages(1);
        setTotalRecords(incoming.length);
        setRefresh(false);
        setRefreshStatusList((prev) => {
          prev[filterBy.productTypes] = false;
          return prev;
        });
        loadingOff();
        return data.result;
      }

      if (data?.type === "error") {
        dispatch(
          setNotification({
            message: data.message,
            type: "error",
          }),
        );
        setRefresh(false);
        loadingOff();
        return;
      }

      loadingOff();
    } catch (err) {
      loadingOff();
      console.log(err.message);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
      setRefresh(false);
    }
  };

  const onLoadMore = () => {
    if (loading || page >= totalPages) return;
    getWOByproductType({ pageNo: page + 1, reset: false });
  };

  const hasMore = page < totalPages;

  /*   All UseEffects
   ********************************************* */

  useEffect(() => {
    if (filterText || selectedLocation) {
      let filteredData = null;
      if (filterText && selectedLocation) {
        filteredData = WOData?.filter((item) => {
          return (
            item?.locationId === parseInt(selectedLocation) &&
            (item?.woId.toString().includes(filterText) ||
              item?.jobName?.toLowerCase().includes(filterText.toLowerCase()) ||
              item?.customerName
                ?.toLowerCase()
                .includes(filterText.toLowerCase()))
          );
        });
        return setFilteredSearchedData(filteredData);
      }
      if (filterText) {
        filteredData = WOData?.filter((item) => {
          return (
            item?.woId.toString().includes(filterText) ||
            item?.jobName?.toLowerCase().includes(filterText.toLowerCase()) ||
            item?.customerName?.toLowerCase().includes(filterText.toLowerCase())
          );
        });
        return setFilteredSearchedData(filteredData);
      }
      if (selectedLocation) {
        filteredData = WOData?.filter((item) => {
          return item?.locationId === parseInt(selectedLocation);
        });
        return setFilteredSearchedData(filteredData);
      }
    } else {
      setFilteredSearchedData(null);
    }
  }, [filterText, selectedLocation, WOData]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      getWOByproductType();
    }, 50);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (refresh) {
      let timeout = setTimeout(() => {
        getWOByproductType();
      }, 50);
      return () => clearTimeout(timeout);
    }
  }, [refresh]);
  useEffect(() => {
    if (refreshStatusList[filterBy.productTypes]) {
      let timeout = setTimeout(() => {
        getWOByproductType();
      }, 50);
      return () => clearTimeout(timeout);
    }
  }, [refreshStatusList[filterBy.productTypes]]);

  return (
    <div
      className={
        tempBoard ? "col-12 p-2 overflow-hidden" : "col-6 p-2 overflow-hidden"
      }
      style={{
        minHeight: tempBoard ? "80%" : "35%",
        maxHeight: tempBoard ? "95%" : "45%",
        position: "relative",
      }}
    >
      {loading && <Spinner />}
      <div className="flex-grow-1 pb-5 bg-white h-100 custom-shadow-sm custom-border-radius ">
        {/* ******************** FilterBy Header ************************* */}
        <div className="topHeader bg-primary text-white custom-border-radius d-flex justify-content-between align-items-center">
          <div>{filterBy.productTypes}</div>
          <div>
            {WOData && WOData?.length && filterBy ? (
              <JobBoardPdf
                filterBy={filterBy}
                workOrderList={
                  filteredSearchedData ? filteredSearchedData : WOData
                }
              />
            ) : (
              <div></div>
            )}
            <button
              onClick={() => {
                setWOData(null);
                setRefresh(true);
              }}
              className="btn btn-sm btn-info"
            >
              Refresh
            </button>
            <button
              onClick={() => {
                setOpenFullView(true);
              }}
              className="btn btn-sm btn-success mx-2"
            >
              Open
            </button>
            {filterText || selectedLocation
              ? filteredSearchedData?.length
              : WOData?.length}
          </div>
        </div>
        <div className="bodyHeader row">
          <div className="col-1 ">W-ID</div>
          <div className="col-4">Job Name</div>
          <div className="col-4">Customer Name</div>
          <div className="col-2">Ship Date</div>
          <div className="col-1 ">Qty</div>
        </div>
        {WOData && WOData?.length ? (
          <div className="bodyContent overflow-auto ">
            {filteredSearchedData
              ? filteredSearchedData?.map((item, index) => (
                  <div
                    onDoubleClick={() => {
                      setSelectedItem((prev) => item);
                      updateSearchParams("selected-work-order", item?.woId);
                      setShowProductsModal(true);
                    }}
                    key={index}
                    className="row item"
                  >
                    <div className="col-1 px-0">W-{`${item?.woId}`}</div>
                    <div className=" col-4 text-nowrap">
                      {item?.jobName?.slice(0, 25)}
                      {item?.jobName?.length >= 25 ? "..." : ""}
                    </div>
                    <div className=" col-4">
                      {item?.customerName?.slice(0, 25)}
                      {item?.customerName?.length >= 25 ? "..." : ""}
                    </div>
                    <div className=" col-2">
                      {item?.WoShipDate ? item?.WoShipDate : "N/A"}
                    </div>
                    <div className=" col-1 text-end">
                      {item?.totalQuantity ? item?.totalQuantity : "N/A"}
                    </div>
                  </div>
                ))
              : WOData &&
                WOData?.map((item, index) => (
                  <div
                    onDoubleClick={() => {
                      setSelectedItem((prev) => item);
                      updateSearchParams("selected-work-order", item?.woId);
                      setShowProductsModal(true);
                    }}
                    key={index}
                    className="row item"
                  >
                    <div className="col-1 px-0">W-{item?.woId}</div>
                    <div className=" col-4 text-nowrap">
                      {item?.jobName?.slice(0, 25)}
                      {item?.jobName?.length >= 25 ? "..." : ""}
                    </div>
                    <div className=" col-4">
                      {item?.customerName?.slice(0, 25)}
                      {item?.customerName?.length >= 25 ? "..." : ""}
                    </div>
                    <div className=" col-2">
                      {item?.WoShipDate ? item?.WoShipDate : "N/A"}
                    </div>
                    <div className=" col-1 text-end">
                      {item?.totalQuantity ? item?.totalQuantity : "N/A"}
                    </div>
                  </div>
                ))}
          </div>
        ) : (
          <div className="flex-center h-50">No Orders</div>
        )}

        <div className="d-flex justify-content-between align-items-center px-2 mt-1">
          <div className="small text-muted">
            Showing {WOData?.length || 0} of {totalRecords || 0}
          </div>
          {hasMore && (
            <button
              onClick={onLoadMore}
              disabled={loading}
              className="btn btn-sm btn-outline-primary"
            >
              {loading ? "Loading..." : "Load More"}
            </button>
          )}
        </div>

        <QuickViewWorkOrder
          filterBy={filterBy}
          // selectedId={selectedItem?.woId}
          updateSearchParams={updateSearchParams}
          show={showProductsModal}
          setShow={setShowProductsModal}
          workOrdersList={WOData}
          refreshFunc={getWOByproductType}
        />

        {/*   View ALL Modal
         ********************************************* */}
        <Modal
          size="xl"
          show={openFullView}
          onHide={() => setOpenFullView(false)}
        >
          <Modal.Body className="scrollbar-hide ">
            <div>
              <JobBoardFullViewData
                filterBy={filterBy}
                WOData={filterText ? filteredSearchedData : WOData}
              />
            </div>
            <div className="text-end">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setOpenFullView(false);
                }}
              >
                Close
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}
